import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import "../styles/Wissenswertes.css";
import styles from '../styles/Wissenswertes.module.css'

const Wissenswertes = () => {
  const [wissenswertesData, setWissenswertesData] = useState([]);
  const [loadingWissenswertes, setLoadingWissenswertes] = useState(true);
  const [errorWissenswertes, setErrorWissenswertes] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const [activeTopOffset, setActiveTopOffset] = useState(-100);
  const sections = useRef([]);

  const Wissenswertes_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Wissenswertes?fields=*&filter[status][_eq]=published';

  const scrollToSection = (id, active) => {
      const element = document.getElementById(id);
      if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
  };

  const scrollActiveSlider = (active) => {
    setActiveTopOffset(active.offsetTop + 3);
  }

  useEffect(() => {
    const fetchWissenswertes = async () => {
      try {
        const response = await axios.get(Wissenswertes_API_URL);
          if (response.data && response.data.data) {
            setWissenswertesData(response.data.data);
          } else {
            setErrorWissenswertes('Нет данных для отображения');
          }
        } catch (error) {
          setErrorWissenswertes('Ошибка при получении данных');
          console.error(error);
        } finally {
          setLoadingWissenswertes(false);
        }
      };

      fetchWissenswertes();
  }, []);

  const handleScroll = () => {
      const pageYOffset = window.scrollY;
      let newActiveSection = null;
      let newActiveNav = document.querySelectorAll('[data-active="true"]')[0];

      sections.current = document.querySelectorAll('[data-section]');

      sections.current.forEach((section) => {
          const sectionOffsetTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;

          if (pageYOffset >= (sectionOffsetTop - 150) && pageYOffset < (sectionOffsetTop - 150) + sectionHeight) {
              newActiveSection = section.id;
              /* console.log(document.querySelectorAll('[data-active="true"]')[0].offsetTop); */
              
          }
      });

      (newActiveNav) ?  setActiveTopOffset(newActiveNav.offsetTop + 3) : setActiveTopOffset(-100);
      setActiveSection(newActiveSection);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll);

      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);

  return (
    <>
      <header className={styles['info-header']}>
        {/* <div className={styles.container}> */}
          <h1>Wissenswertes</h1>
        {/* </div> */}
      </header>
      <div className={styles.container}>
        {!loadingWissenswertes && !errorWissenswertes && (
          <>
            <nav className={styles['info-nav']}>
              <ul>
                { wissenswertesData.map((info, idx) => {
                  return (
                    <li key={idx}>
                      <button
                        type="button"
                        className={(activeSection === info.Kurzname) ? 'active' : ''}
                        onClick={(e) => scrollToSection(info.Kurzname, e.target)}
                        onChange={(e) => scrollActiveSlider(e.target)}
                        data-active={(activeSection === info.Kurzname) ? 'true' : 'false'}>
                      {info.Kurzname}</button>
                    </li>
                  )})
                }
              </ul>
              <div className={styles['active-slider']} style={{top: `${activeTopOffset}px`}}></div>
            </nav>
            <main>
              { wissenswertesData.map((info, idx) => {
                return (
                  <div key={idx} className={styles['info-block']} id={info.Kurzname} data-section>
                    <div className={styles['info-container']}>
                      <h2 className={styles['info-title']}>{info.Headline}</h2>
                      <div className={styles['info-content']} dangerouslySetInnerHTML={{__html:info.Content}} />
                    </div>
                  </div>
                )})
              }
            </main>
          </>
        )}
      </div>
    </>
  )
}

export default Wissenswertes;